import React, { useEffect } from 'react';
import { Header, FormRegister } from './components';
import img from '../commons/img/logg.svg';
import imgLogo from '../commons/img/ubaform-logo.svg';

export default function Login() {
  useEffect(() => {
    document.title = `Register - Nadi Admin`;
  }, []);

  return (
    <div className='min-h-screen bg-white flex'>
      <div className='hidden lg:block relative w-0 flex-1 bg-gray-100 justify-center'>
        <img className='absolute inset-0 w-600 object-cover' src={img} alt='' />
      </div>
      <div className='flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24'>
        <div className='mx-auto w-full max-w-sm lg:w-96'>
          <div>
            <img
              className='h-6 w-auto mb-10'
              src={imgLogo}
              alt='Ubaform Logo'
            />
            <h2 className='mt-6 text-3xl font-extrabold text-gray-900'>
              Let's Create Your Account
            </h2>
          </div>
          <FormRegister />
        </div>
      </div>
    </div>
  );
}
